import { render, staticRenderFns } from "./Params.vue?vue&type=template&id=d52dc626&scoped=true"
import script from "./Params.vue?vue&type=script&lang=js"
export * from "./Params.vue?vue&type=script&lang=js"
import style0 from "./Params.vue?vue&type=style&index=0&id=d52dc626&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d52dc626",
  null
  
)

export default component.exports